// extracted by mini-css-extract-plugin
export default {"dot":"CustomSkills_dot__inmTk"};